import { SerializedData, Store } from "bernie-core";
import { action, observable } from "mobx";
import { Template, FlexBffTemplateResponse, ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";
import { Logger } from "bernie-logger";
import { FlexModuleModelStore } from "src/stores/FlexModuleModelStore";

/**
 * Mobx store that saves the template data structure for a given page.
 * - bffResponse.template is only populated on the template path
 */
export class TemplateStore extends Store {
  @observable
  public template: Template;

  public constructor(state: SerializedData = {}, logger: Logger) {
    super(state, logger);
  }

  public hydrate(data: SerializedData): void {
    Object.assign(this, data);
  }

  /**
   * initializes TemplateStore with data from other stores. Called from controller
   * @param  {FlexBffTemplateResponse} bffResponse
   * @param  {ExtendedContextStore} context
   * @param  {FlexModuleModelStore} flexModuleModelStore
   * @returns void
   */
  @action
  public setup(
    bffResponse: FlexBffTemplateResponse | undefined,
    context: ExtendedContextStore,
    flexModuleModelStore: FlexModuleModelStore
  ) {
    if (!bffResponse) {
      return;
    }

    this.template = bffResponse.template;
  }
}
